// Centralized role-based UI permissions.
// Backend enforces these too (see /app/backend/server.py). Use these flags to hide
// create / edit / delete / import buttons that the user cannot use anyway.
//
// Usage:
//   import { can } from "@/lib/rbac";
//   {can.editStudents(user) && <Button>Add Student</Button>}

const ADMIN_LIKE = ["super_admin", "school_admin", "academic"];
const HR_LIKE = ["super_admin", "school_admin", "hr"];
const FINANCE_LIKE = ["super_admin", "school_admin", "finance"];
const TEACHER_LIKE = ["super_admin", "school_admin", "academic", "teacher"];

const has = (user, roles) => !!user && roles.includes(user.role);

export const can = {
  // Academic structure CRUD (stages/grades/classes/subjects/timetable)
  editAcademicStructure: (u) => has(u, ADMIN_LIKE),
  editTimetable:         (u) => has(u, ADMIN_LIKE),

  // Students
  editStudents:    (u) => has(u, ADMIN_LIKE),
  importStudents:  (u) => has(u, [...ADMIN_LIKE, "hr"]),

  // Teachers / Parents
  editTeachers:    (u) => has(u, ADMIN_LIKE),
  editParents:     (u) => has(u, [...ADMIN_LIKE, "hr"]),

  // Attendance / grades / behavior / homework — created by teaching staff
  markAttendance:  (u) => has(u, TEACHER_LIKE),
  enterGrades:     (u) => has(u, TEACHER_LIKE),
  addBehavior:     (u) => has(u, TEACHER_LIKE),
  addHomework:     (u) => has(u, TEACHER_LIKE),

  // Announcements
  createAnnouncement: (u) => has(u, TEACHER_LIKE),

  // Finance
  manageFees:      (u) => has(u, FINANCE_LIKE),
  createInvoice:   (u) => has(u, FINANCE_LIKE),

  // HR
  manageHR:        (u) => has(u, HR_LIKE),

  // Transport
  editTransport:   (u) => has(u, ADMIN_LIKE),

  // System / Settings
  viewSettings:    (u) => has(u, ["super_admin"]),
  viewAudit:       (u) => has(u, ["super_admin", "school_admin"]),

  // Self
  isReadOnlyRole:  (u) => has(u, ["parent", "student", "driver"]),
};
